import React from 'react';
import PropTypes from 'prop-types';

export default function TCP({
  Checkbox, Label, useInput, checked,
}) {
  return (
    <React.Fragment>
      <Checkbox id="tc" type="checkbox" checked={checked} {...useInput('tc')} />
      <Label htmlFor="tc">
        {'I agree to Livewire’s '}
        <a href="/company/terms_and_conditions" target="_blank">Terms and Conditions</a>
        {' and '}
        <a href="/company/privacy" target="_blank">Privacy Disclaimer</a>
      </Label>
    </React.Fragment>
  );
}

TCP.propTypes = {
  Checkbox: PropTypes.elementType.isRequired,
  Label: PropTypes.elementType.isRequired,
  useInput: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
};
